// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// TODO: get this out
import {sync} from 'vuex-router-sync'
import Vuelidate from 'vuelidate'
import VueAnalytics from 'vue-analytics'
import store from '@/store/'
import App from '@/App'
import router from '@/router'

Vue.config.productionTip = false

sync(store, router)

/* eslint-disable no-undef */

Vue.use(Vuelidate)
Vue.use(VueAnalytics, {
  id: 'UA-148995813-1',
  router,
  autoTracking: {exception: true},
  debug: {
    eanbled: !process.env.IS_PRODUCTION,
    sendHitTask: process.env.IS_PRODUCTION
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js